export default __webpack_public_path__ + "static/media/slide5.742c9bc7.jpg";